import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';

function Forbidden() {
    return (
        <div className="min-h-[60vh] flex items-center justify-center p-6">
            <Result
                status="403"
                title="403"
                subTitle="Sorry, you are not authorized to access this page."
                extra={<Link to="/"><Button type="primary">Back Home</Button></Link>}
            />
        </div>
    );
}

export default Forbidden;


